import React from 'react';
import ReactDOM from 'react-dom/client';
import "quill/dist/quill.snow.css"; // Default theme
import "quill/dist/quill.bubble.css"; // Alternative theme


import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


